var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddedConvenienceIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.867 46.18l-5.821-1.41L45.942 8.307l5.82 1.409L27.868 46.18z",
    fill: "url(#added-convenience-icon_svg__paint0_linear_4452_6515)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.595 36.38l14.123 13.089 2.497 2.224-5.821-1.408-2.497-2.224L5.772 34.97l5.822 1.409z",
    fill: "#360055"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.763 9.715l2.463 2.278-23.89 36.456-2.122 3.245-2.497-2.225-14.123-13.09 2.133-3.247 14.14 13.048L51.763 9.715z",
    fill: "#9700E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.594 36.38l-5.82-1.41 2.132-3.246 5.821 1.408-2.133 3.248z",
    fill: "#7C02BB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "added-convenience-icon_svg__paint0_linear_4452_6515",
    x1: 48.5,
    y1: 9.68,
    x2: 52.066,
    y2: 40.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A00A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#5A008F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#360055"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yNy44NjY5IDQ2LjE3OTdMMjIuMDQ1OSA0NC43NzA3TDQ1Ljk0MTkgOC4zMDU2Nkw1MS43NjI5IDkuNzE0NjZMMjcuODY2OSA0Ni4xNzk3WiIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyXzQ0NTJfNjUxNSkiLz4KPHBhdGggZD0iTTExLjU5NDcgMzYuMzc5OUwyNS43MTc4IDQ5LjQ2ODhMMjguMjE0OCA1MS42OTM0TDIyLjM5MzYgNTAuMjg1MkwxOS44OTY1IDQ4LjA2MDVMNS43NzM0NCAzNC45NzA3TDExLjU5NDcgMzYuMzc5OVoiIGZpbGw9IiMzNjAwNTUiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01MS43NjMyIDkuNzE0ODRMNTQuMjI2MiAxMS45OTI4TDMwLjMzNTIgNDguNDQ4OEwyOC4yMTQyIDUxLjY5MzhMMjUuNzE3MiA0OS40Njg4TDExLjU5NDIgMzYuMzc5OEwxMy43MjcyIDMzLjEzMThMMjcuODY3MiA0Ni4xNzk4TDUxLjc2MzIgOS43MTQ4NFoiIGZpbGw9IiM5NzAwRTUiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMS41OTQ0IDM2LjM3OTZMNS43NzM0NCAzNC45NzA2TDcuOTA2NDQgMzEuNzIzNkwxMy43Mjc0IDMzLjEzMTZMMTEuNTk0NCAzNi4zNzk2WiIgZmlsbD0iIzdDMDJCQiIvPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyXzQ0NTJfNjUxNSIgeDE9IjQ4LjUiIHkxPSI5LjY3OTY5IiB4Mj0iNTIuMDY2MiIgeTI9IjQwLjgwOCIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjNkEwMEE4Ii8+CjxzdG9wIG9mZnNldD0iMC4yIiBzdG9wLWNvbG9yPSIjNUEwMDhGIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzM2MDA1NSIvPgo8L2xpbmVhckdyYWRpZW50Pgo8L2RlZnM+Cjwvc3ZnPgo=";
export { SvgAddedConvenienceIcon as ReactComponent };